import {Component, ElementRef, TemplateRef} from '@angular/core';
import {NotificationService} from '@services/notification/notification.service';
import {Toast} from '@models/toast/toast';

@Component({
    selector: 'scitis-notification-container',
    template: `
    @for (toast of notificationService.toasts; track toast) {
      <ngb-toast
        [class]="toast.classname"
        (shown)="onShown()"
        [autohide]="toast.autohide ?? true"
        [delay]="toast.delay || 5000"
        (hidden)="hideToast(toast)">
        @if (isTemplate(toast.textOrTpl)) {
          <ng-template [ngTemplateOutlet]="returnTemplate(toast.textOrTpl)" [ngTemplateOutletContext]="{toast: toast}"></ng-template>
        } @else {
          <span [innerHTML]="toast.textOrTpl"></span>
        }
        <ng-template ngbToastHeader >
          @if (isTemplate(toast.header)) {
            <ng-template [ngTemplateOutlet]="returnTemplate(toast.header)"></ng-template>
          } @else {
            <strong [innerText]="toast.header" class="mr-auto"></strong>
          }
        </ng-template>
      </ngb-toast>
    }
    `,
    host: { '[class.ngb-toasts]': 'true' },
    standalone: false
})
export class NotificationContainerComponent {

  constructor(
    public notificationService: NotificationService,
    private elem: ElementRef
  ) {
  }

  isTemplate(data: TemplateRef<any> | string): boolean {
    return data instanceof TemplateRef;
  }

  hideToast(toast: Toast): void {
    this.notificationService.remove(toast);
    if(toast.removalFunction) {
      toast.removalFunction(toast);
    }
  }

  // TODO retest after update bootstrap
  public onShown(): void {
    const btnCloseCollection = this.elem.nativeElement.getElementsByClassName('btn-close');
    for (const btnClose of btnCloseCollection) {
      if (!btnClose.classList.contains('close')) {
        btnClose.classList.add('close');
      }
    }
  }
  returnTemplate(data: TemplateRef<any> | string): TemplateRef<any> {
    return data as TemplateRef<any>;
  }
}
